import React, { useState, forwardRef, useImperativeHandle } from 'react'
import classNames from 'classnames'

import LabelWithInput from '../../tmoForms/LabelWithInput'
import TmoSvg from '../TmoSvg'

import style from './TmoSearch.module.css'

const TmoSearch = forwardRef(
  (
    {
      onFilter,
      options,
      placeholder,
      className,
      originalList,
      renderIcon,
      iconClass,
      isMultiSelect,
      selectComponent,
      testId,
      isActionIconBtn,
      ariaLabel,
      ariaPlaceholder,
      startIndex=0
    },
    ref
  ) => {
    const [searchText, setSearchText] = useState('')
    const [ariaFocusMessage, setAriaFocusMessage] = useState('');
    const [text, setText] = useState('')
    const [dropDownOptions, setDropDownOptions] = useState([{ value: '' }])
    const [selectedOptions, setSelectedOptions] = useState([])
    const selectStyles = {
      control: (provided) => ({
        ...provided,
        borderColor: '#89888b',
        backgroundColor: '#f2f2f2',
        borderRadius: '0.25rem',
        border: '0',
        minHeight: '3rem',
        padding: '0.4rem 0.75rem 0.75rem 2rem',
        boxShadow: null,
        ['&:hover']: null
      }),
      option: (styles, { isFocused }) => {
        return {
          ...styles,
          color: '#121212',
          backgroundColor: isFocused ? '#ffffff' : null,
          cursor: 'pointer',
          padding: '0.5rem',
          ':hover': {
            color: '#e20074'
          }
        }
      },
      multiValue: (base) => ({
        ...base,
        backgroundColor: '#e20074',
        color: '#fff',
        borderRadius: '2rem',
        flex: 'none',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        minWidth: '2rem',
        '@media only screen and (max-width: 1366px)': {
          ...base['@media only screen and (max-width: 1366px)'],
          width: '130px'
        }
      }),
      multiValueLabel: (base) => ({
        ...base,
        color: '#fff',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        minWidth: '2rem'
      }),
      multiValueRemove: (base) => ({
        ...base,
        color: '#fff',
        ':hover': {
          backgroundColor: '#e20074',
          color: '#fff'
        }
      }),
      placeholder: (base) => ({
        ...base,
        width: '99%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        top: '60%'
      }),
      clearIndicator: (base) => ({
        ...base,
        padding: '0',
        cursor: 'pointer',
        color: '#4C4C4C'
      })
    }
    const handleChange = (e) => {
      setSearchText(e.target.value)
      if (e.key === 'Enter') {
        ApplyFilter(e.target.value)
      }
    }
    const handleClear = () => {
      setSearchText('')
      setText('')
      ApplyFilter('')
    }
    const onFocus = ({ focused }) => {
      const msg = `You are currently focused on option ${focused.label}`;
      setAriaFocusMessage(msg);
      return msg;
    };
    const FilterData = (text, filteredList) => {
      let keyword = text === undefined ? searchText : text
      let list = filteredList !== undefined ? filteredList : originalList
      return list.filter((item) => {
        for (let i = 0; i < options.length; i++) {
          if (
            item[options[i]] !== undefined &&
            item[options[i]].toLowerCase().includes(keyword.toLowerCase())
          ) {
            return true
          }
        }
        return false
      })
    }
    const buildFilter = (selection) => {
      let query = {}
      let values = selection !== undefined ? selection : selectedOptions
      for (let i = 0; i < values.length; i++) {
        for (let j = 0; j < options.length; j++) {
          if (
            values[i].key &&
            values[i].key === options[j] &&
            query[options[j]]
          ) {
            query[options[j]] =
              query[options[j]].constructor === Array
                ? [...query[options[j]], values[i].value]
                : [query[options[j]], values[i].value]
          }
          if (
            values[i].key &&
            values[i].key === options[j] &&
            !query[options[j]]
          ) {
            query[options[j]] = values[i].value
          }
        }
      }
      return query
    }
    const FilterMultiSearch = (selection, filteredList) => {
      let list = filteredList !== undefined ? filteredList : originalList
      let query = buildFilter(selection)
      return list.filter((item) => {
        for (let key in query) {
          if (query[key].length === 0) {
            return true
          }
          if (
            item[key] === undefined ||
            !query[key].includes(item[key].toString())
          ) {
            return false
          }
        }
        return true
      })
    }
    const ApplyFilter = (text) => {
      let result = FilterData(text)
      onFilter({ list: result, parentEvent: false })
    }
    const getSelectionOptions = (e) => {
      setSearchText(e)
      if (e && e.length >= 2) {
        let result = FilterData(e)
        let temp = []
        for (let i = 0; i < options.length; i++) {
          temp = [
            ...temp,
            ...result.map((e) => ({
              value: e[options[i]],
              key: options[i]
            }))
          ]
        }
        temp.sort((a, b) => a.toString().localeCompare(b.toString()))
        const newOptions = temp.map((e) => ({
          value: e.value,
          label: e.value,
          key: e.key
        }))
        setDropDownOptions([...newOptions])
      }
    }
    const handleOnChange = (selection) => {
      if (selection) {
        setSelectedOptions(selection)
        let result = FilterMultiSearch(selection)
        onFilter({ list: result, parentEvent: false })
      } else {
        setSelectedOptions([])
        let result = FilterMultiSearch([])
        onFilter({ list: result, parentEvent: false })
      }
    }
    useImperativeHandle(ref, () => ({
      ApplyFilters(filteredList) {
        let result = FilterData(undefined, filteredList)
        onFilter({ list: result, parentEvent: true })
      },
      ApplyMultiSelectFilters(filteredList) {
        let result = FilterMultiSearch(undefined, filteredList)
        onFilter({ list: result, parentEvent: true })
      }
    }))
    return (
      <div
        className={isActionIconBtn ? style.search_bar_icon : style.search_bar}
      >
        {isMultiSelect ? (
          <LabelWithInput
            inputType='primary'
            placeholder={placeholder}
            styles={selectStyles}
            formComponent={selectComponent}
            components={{
              DropdownIndicator: () => null,
              IndicatorSeparator: () => null
            }}
            isMulti
            isSearchable
            openMenuOnClick={false}
            openMenuOnFocus={false}
            options={dropDownOptions}
            onInputChange={getSelectionOptions}
            onChange={handleOnChange}
            classNamePrefix='select'
            className={style.custom_label}
            isDisabled={!originalList || originalList.length === 0}
            data-testid={testId}
            labelText={placeholder}
            tabIndex={startIndex}
            ariaLiveMessages={{
              onFocus,
            }}
          />
        ) : (
          <React.Fragment>
            <input
              className={classNames(
                isActionIconBtn
                  ? style.input_action_primary
                  : style.input_primary,
                text && style.input_outline_primary,
                className
              )}
              onChange={(e) => setText(e.target.value)}
              value={text}
              onKeyUp={handleChange}
              placeholder={placeholder}
              disabled={!originalList || originalList.length === 0}
              data-testid={testId}
              type="text"
              aria-label={ariaLabel}
              aria-placeholder={ariaPlaceholder}
              tabIndex={startIndex}
            />
            {text && (
              <TmoSvg
                svgId='close'
                className={style.close_icon}
                role='button'
                onClick={handleClear}
                ariaLabel="Close Icon"
                tabIndex={startIndex + 1}
              />
            )}
          </React.Fragment>
        )}
        <span
          className={classNames(
            (className = isActionIconBtn ? style.primary_icon : style.icon),
            iconClass
          )}
        >
          {renderIcon}
        </span>
      </div>
    )
  }
)

export default TmoSearch
